/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getUsers } from 'app/shared/reducers/user-management';
import { getEntities as getContactDetails } from 'app/entities/contact-details/contact-details.reducer';
import { createEntity, getEntity, reset, updateEntity } from './blood-bank.reducer';

export const BloodBankUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const contactDetails = useAppSelector(state => state.contactDetails.entities);
  const bloodBankEntity = useAppSelector(state => state.bloodBank.entity);
  const loading = useAppSelector(state => state.bloodBank.loading);
  const updating = useAppSelector(state => state.bloodBank.updating);
  const updateSuccess = useAppSelector(state => state.bloodBank.updateSuccess);

  const handleClose = () => {
    navigate(`/blood-bank${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
    dispatch(getUsers({}));
    dispatch(getContactDetails({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...bloodBankEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
      user: users.find(it => it.id.toString() === values.user?.toString()),
      contactCode: contactDetails.find(it => it.id.toString() === values.contactCode?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bloodBankEntity,
          hospital: bloodBankEntity?.hospital?.id,
          user: bloodBankEntity?.user?.id,
          contactCode: bloodBankEntity?.contactCode?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.bloodBank.home.createOrEditLabel" data-cy="BloodBankCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.bloodBank.home.createOrEditLabel">Create or edit a BloodBank</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="blood-bank-id"
                  label={translate('tinyMedicRestApp.bloodBank.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.name')}
                id="blood-bank-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.registrationCode')}
                id="blood-bank-registrationCode"
                name="registrationCode"
                data-cy="registrationCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.registrationAuth')}
                id="blood-bank-registrationAuth"
                name="registrationAuth"
                data-cy="registrationAuth"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.registrationState')}
                id="blood-bank-registrationState"
                name="registrationState"
                data-cy="registrationState"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.email')}
                id="blood-bank-email"
                name="email"
                data-cy="email"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.returnInstructions')}
                id="blood-bank-returnInstructions"
                name="returnInstructions"
                data-cy="returnInstructions"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.taxCode')}
                id="blood-bank-taxCode"
                name="taxCode"
                data-cy="taxCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.billPrefix')}
                id="blood-bank-billPrefix"
                name="billPrefix"
                data-cy="billPrefix"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.createdBy')}
                id="blood-bank-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.active')}
                id="blood-bank-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.cursor')}
                id="blood-bank-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.lastUpdated')}
                id="blood-bank-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.microSec')}
                id="blood-bank-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodBank.timestampEntry')}
                id="blood-bank-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="blood-bank-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.bloodBank.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-bank-user"
                name="user"
                data-cy="user"
                label={translate('tinyMedicRestApp.bloodBank.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-bank-contactCode"
                name="contactCode"
                data-cy="contactCode"
                label={translate('tinyMedicRestApp.bloodBank.contactCode')}
                type="select"
              >
                <option value="" key="0" />
                {contactDetails
                  ? contactDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/blood-bank" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BloodBankUpdate;
